import { useEffect, useRef, useState } from "react";
import { useHref, useLocation } from "react-router-dom";
import Helmet from "react-helmet";

const PrerenderRedirectStatus = ({ lang: _lang }: { lang?: string }) => {
  const location = useLocation();
  const first = useRef(true);
  const [redirectLocation, setRedirectLocation] = useState("");
  const pathLang = useHref("/");
  const lang = _lang ? "/" + _lang : pathLang;

  useEffect(() => {
    if (first.current) {
      first.current = false;
    } else {
      const to = `${lang}${location.pathname}${location.search}`;
      console.debug("set prerender redirect", to);
      setRedirectLocation(window.location.origin.toString() + encodeURI(to));
    }
  }, [lang, location]);

  return redirectLocation ? (
    <Helmet>
      <meta name="prerender-status-code" content={"302"} />
      <meta name="prerender-header" content={"Location: " + redirectLocation} />
    </Helmet>
  ) : null;
};

export default PrerenderRedirectStatus;
